import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { color, getComponentOverride } from '../../../system';
import { makeBEM } from '../../../utils';
import { TableCell } from '../TableCell';
import { transitionDurationInSec } from '../../../constants';
import { TABLE_HEAD_CELL_CLASS_PREFIX } from './constants';

var getRootStyle = function getRootStyle(_ref) {
  var sortingEnabled = _ref.sortingEnabled;
  var result = {};

  if (sortingEnabled) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            cursor: pointer;\n            user-select: none;\n        "])), result);
  }

  return result;
};

var alphabeticalIconClassName = makeBEM(TABLE_HEAD_CELL_CLASS_PREFIX, 'AlphabeticalIcon');
var numericalIconClassName = makeBEM(TABLE_HEAD_CELL_CLASS_PREFIX, 'NumericalIcon');
export var TableHeadCellRoot = styled(TableCell)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    .", ", .", " {\n        opacity: 0;\n        transition: opacity ", "s ease;\n    }\n    &:hover {\n        .", ", .", " {\n            opacity: 1;\n        }\n        background-color: ", ";\n    }\n\n    ", ";\n    ", ";\n"])), alphabeticalIconClassName, numericalIconClassName, transitionDurationInSec, alphabeticalIconClassName, numericalIconClassName, color('primary.lightest'), getRootStyle, getComponentOverride('TableHeadCell'));